import React from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';
import DesktopDashboard from './dashboard/Dashboard';
import MobileDashboard from '../mobile/components/dashboard/Dashboard';

const ResponsiveDashboard = () => {
  const isMobile = useMediaQuery('(max-width: 599px)');

  return isMobile ? <MobileDashboard /> : <DesktopDashboard />;
};

export default ResponsiveDashboard; 